/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DomainInputs */

const en_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const fr_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine`)
};

const de_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const it_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio`)
};

const ru_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Домен`)
};

const es_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio`)
};

const zh_cn2_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领域`)
};

const ja_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメイン`)
};

const hi_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्षेत्र`)
};

const pt_pt2_domain = /** @type {(inputs: DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio`)
};

/**
* | output |
* | --- |
* | "Domain" |
*
* @param {DomainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const domain = /** @type {((inputs?: DomainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DomainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_domain(inputs)
	if (locale === "de") return de_domain(inputs)
	if (locale === "it") return it_domain(inputs)
	if (locale === "ru") return ru_domain(inputs)
	if (locale === "es") return es_domain(inputs)
	if (locale === "zh-CN") return zh_cn2_domain(inputs)
	if (locale === "ja") return ja_domain(inputs)
	if (locale === "hi") return hi_domain(inputs)
	if (locale === "pt-PT") return pt_pt2_domain(inputs)
	return en_domain(inputs)
});